import { styled } from "@mui/system";
import { TabPanel } from "@mui/lab";

const StyledTabPanel = styled(TabPanel)(({ theme }: any) => ({
  padding: 0,
}));

export default StyledTabPanel;
